<template>
  <v-app v-if="userAuth" :class="`app-root ${getForAccessibility ? 'for-accessibility-app' : ''}`">
    <app-toolbar class="app--toolbar" />
    <app-drawer class="app--drawer" />
    <v-main class="pt-12">
      <div style="padding-bottom: 4rem" class="page-wrapper mx-6">
        <el-system-info />
        <router-view />
      </div>
      <app-footer></app-footer>
    </v-main>
    <app-fab />
    <modal-idle v-model="showIdle" />
    <modal-ireg-agreement
      v-model="showAgreementModal"
      :loading="loading"
      @confirmAgreement="confirmAgreement"
      @cancelAgreement="cancelAgreement"
    />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import checkUser from '@/mixins/checkUser'
import AppToolbar from './ireg/AppToolbar'
import AppDrawer from './ireg/AppDrawer'
import AppFab from './ireg/AppFab'
import AppFooter from './ireg/AppFooter'
import ModalIdle from '@/views/ModalIdle'
import ModalIregAgreement from '@/components/modals/ModalIregAgreement'

export default {
  name: 'LayoutDefault',
  components: {
    AppToolbar,
    AppDrawer,
    AppFab,
    AppFooter,
    ModalIdle,
    ModalIregAgreement,
  },
  mixins: [checkUser],
  data() {
    return {
      loading: false,
      userAuth: false,
      showDrawer: true,
      showIdle: false,
    }
  },
  computed: {
    ...mapGetters(['userID', 'userAgreement', 'getForAccessibility']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    showAgreementModal: {
      set(value) {
        //
      },
      get() {
        return !this.userAgreement
      },
    },
  },
  watch: {
    $route() {
      this.$axios.get(`system-notifications/application/ireg`).then((res) => {
        this.$store.dispatch('systemNotification', res.data)
      })
    },
    isAppIdle(val) {
      if (val && !this.showIdle && !this.isLocal) {
        this.$store.dispatch('logout').then(() => {
          this.showIdle = true
        })
      }
    },
  },
  created() {
    this.$store.dispatch('changeLanguage', {
      lang: 'lt',
      i18n: this.$i18n,
      public: true,
    })
    this.checkUser()
    if(this.getForAccessibility){
      document.documentElement.style.setProperty('--scrollbar-color', 'gray');
      document.documentElement.style.setProperty('--scrollbar-hover-color', 'gray');
    }
  },
  methods: {
    confirmAgreement(ids) {
      this.loading = true
      let data = {
        user_id: this.userID,
        read_understood: true,
        ids: ids,
      }
      this.$axios
        .post(`security-notifications-agreements`, data)
        .then((res) => {
          this.$store.dispatch('userAgreement', true)
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelAgreement() {
      this.$store.dispatch('logout').then(() => {
        this.$root.$emit('SHOW_SNACKBAR', {
          text: this.$t('Atsijungta sėkmingai'),
          color: 'success',
        })
        this.$router.push({ name: 'login' })
      })
    },
  },
}
</script>

<style lang="sass" scoped>
.app-root
  background: #f5f5f5
.page-wrapper
  min-height: calc(100vh - 200px)
</style>
